module.exports = __webpack_public_path__ + "img/2012-08-18 10.52.56.d2f8b10d.jpg";